import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import { getDivisor, getIntervalLabel } from "../../../../utils/stripe-helpers";

export const PlanDetails = ({ plan, type = "press", user }) => {
  const { t } = useTranslation("coaching-portal");
  const { pressCustomBranding = {} } = user;
  const {
    nickname,
    currency,
    unit_amount,
    recurring,
    metadata = {},
    features,
    activeCount,
    facilikey = [],
  } = plan;
  const { access, trial_days } = metadata;
  const divisor = getDivisor(currency);
  const price = unit_amount / divisor;
  const { gymLocations = [] } = pressCustomBranding;
  const locations = gymLocations.filter((value) =>
    facilikey.includes(value.facilikey)
  );

  const planName =
    type === "push" ? getIntervalLabel(recurring, t) : nickname || "-";

  return (
    <Modal className="Plan-Modal" title={planName} toClear={["plan", "type"]}>
      <div className="body modal-body">
        <p className="p2">{t("planManager.planDetails.name")}</p>
        <p>{planName}</p>
        <p className="p2">{t("planManager.planDetails.price")}</p>
        <p>{price}</p>
        <p className="p2">{t("planManager.planDetails.currency")}</p>
        <p>{currency.toUpperCase()}</p>
        <p className="p2">{t("planManager.planDetails.interval")}</p>
        <p>{getIntervalLabel(recurring, t)}</p>
        <p className="p2">{t("planManager.planDetails.includedFeatures")}</p>
        {features?.length ? (
          <ul>
            {features.map((feature) => (
              <li key={feature} className="value">
                {feature}
              </li>
            ))}
          </ul>
        ) : (
          <span className="value">-</span>
        )}
        {type === "press" && access && (
          <>
            <p className="p2">{t("planManager.planDetails.userAccess")}</p>
            <p>
              {access.toUpperCase()} Access ({activeCount}{" "}
              {activeCount === 1
                ? t("planManager.planDetails.user")
                : t("planManager.planDetails.usersCount")}
              )
            </p>
          </>
        )}
        {type !== "press" && (
          <>
            <p className="p2">{t("planManager.planDetails.users")}</p>
            <p>{activeCount}</p>
          </>
        )}
        {type === "push" && (
          <>
            <p className="p2">{t("planManager.planDetails.freeTrial")}</p>
            <p>
              {!trial_days
                ? t("planManager.planDetails.no")
                : trial_days > 1
                  ? `${trial_days} ${t("planManager.planDetails.days")}`
                  : `${trial_days} ${t("planManager.planDetails.day")}`}
            </p>
          </>
        )}
        {locations.length ? (
          <>
            <p className="p2">{t("planManager.planDetails.keyAccess")}</p>
            <ul>
              {locations.map(({ gymName, gymLocation, gymContact }) => (
                <li
                  key={`${gymName}-${gymLocation}-${gymContact}`}
                  className="value"
                >
                  {gymName} ({gymLocation})
                </li>
              ))}
            </ul>
          </>
        ) : null}
      </div>
    </Modal>
  );
};
